(function () {
  window.theme = window.theme || {};

  /**
   * Fetch the current cart and update all header cart-count badges.
   * Shared by sticky-atc-bar.js, quick-atc.js, and any script that
   * dispatches the "cart:refresh" custom event.
   */
  window.theme.updateCartCount = function updateCartCount() {
    fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: "application/json" },
    })
      .then((res) => {
        return res.json();
      })
      .then((cart) => {
        const badgeTemplate = document.querySelector(
          "[data-cart-count-badge-template]",
        );
        document.querySelectorAll("[data-header-cart-link]").forEach((link) => {
          let badge = link.querySelector("[data-header-cart-count]");
          if (cart.item_count > 0) {
            if (!badge && badgeTemplate) {
              badge = badgeTemplate.content
                .cloneNode(true)
                .querySelector("[data-header-cart-count]");
              link.appendChild(badge);
            }
            if (badge) {
              badge.textContent = cart.item_count;
            }
          } else if (badge) {
            badge.remove();
          }
        });
      })
      .catch(() => {
        /* Silent — badge update is non-critical UI */
      });
  };

  /**
   * Serialise cart mutations so only one /cart/change.js (or /cart/update.js)
   * request is in-flight at a time. Shopify rejects concurrent cart writes
   * with a 400 ("no valid ID or line parameters").
   *
   * Usage: const cart = await window.theme.cartMutate(() => fetch(...));
   */
  let pending = Promise.resolve();
  window.theme.cartMutate = function cartMutate(fn) {
    const next = pending.then(fn, fn);
    pending = next.catch(() => {});
    return next;
  };

  /* Allow other scripts to trigger a cart count refresh via event */
  document.addEventListener("cart:refresh", window.theme.updateCartCount);

  /* ── Intercept fetch to detect external cart mutations ────────
     When any script (apps, widgets) calls a cart endpoint,
     dispatch cart:refresh so the drawer and badges stay in sync. */
  const CART_MUTATE_RE = /\/cart\/(add|change|update|clear)\.js/;
  const originalFetch = window.fetch;

  window.fetch = function cartInterceptFetch(...args) {
    const [input, init] = args;
    const url = typeof input === "string" ? input : input?.url || "";
    const method = (init?.method || "GET").toUpperCase();
    const isCartMutation = method === "POST" && CART_MUTATE_RE.test(url);

    const result = originalFetch.apply(this, args);

    if (isCartMutation) {
      result
        .then((res) => {
          if (res.ok) {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        })
        .catch(() => {});
    }

    return result;
  };
})();
